






import Vue from 'vue'
import userCreate from '@/components/Users/UserCreate/UserCreate.vue'
export default Vue.extend({
  components: {
    userCreate
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('saveGuard/confirm', 'createUser').then(() => {
      next()
    }).catch(() => {
      next(false)
    })
  }
})
